<template>
    <div>
        <div class="row">
            <div class="col-xl-5 p-0">
                <div class="h1 labgrotesque-bold text-xl-center text-left px-xl-0 px-4">
                    <span :class="[{'link': serviceselected}]" @click="exitFromDetail()">{{ $t($route.meta.title) }}</span>
                    <hr class="hr-title-mobile">
                </div>
            </div>

            <div class="col-xl-5 p-0">
                <div v-if="currentslick" class="h1 text-red labgrotesque-bold text-left px-xl-0 px-4 page-title">
                    <hr class="hr-title">
                    <span v-html="currentslick.title"></span>
                </div>

                <div class="description px-4 px-xl-0 service-selected-0" v-if="currentslick && !serviceselected" v-html="currentslick.field_descrizione"></div>
            </div>
        </div>

        <div class="row service-selected-0" v-if="!serviceselected" v-show="showservices">
            <div class="col-xl-10 offset-xl-1 col-12">
                <div :id="idslickcarousel" v-if="services.length > 0">
                    <div v-for="service in services">
                        <div class="item">
                            <h4 class="content labgrotesque-bold text-center w-75" v-html="service.title"></h4>
                        </div>
                    
                        <div class="img d-none" @click="serviceDetails(service)">
                            <img class="imf-fluid" :src="service.field_servizi_logo">
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="row service-selected-1 mt-5">
            <template v-if="serviceselected">
                <div class="col-xl-5 px-0">
                    <div id="carousel-service" class="d-flex align-items-center h-100">
                        <carousel-3d ref="carouselgallery" :perspective="0" :space="200" :display="8" :bias="'right'" :width="500" :height="500" :animationSpeed="750" :clickable="false"
                        @before-slide-change="onBeforeSlideChange">
                            <slide :index="index" :key="index" v-for="(path, index) in gallery">
                                <img class="img-fluid" :src="path" @click="clickSlide($event, index)">
                            </slide>
                        </carousel-3d>
                    </div>
                </div>

                <div class="col-xl-3 px-xl-0 px-4">
                    <div class="mt-xl-5 pt-xl-5">
                        <div class="h2 labgrotesque-bold" v-html="serviceselected.field_servizi_sottotitolo"></div>
                        <div v-html="serviceselected.body"></div>
                    </div>
                </div>

                <div class="col-xl-4 p-xl-5 px-4 py-3 d-flex align-items-center">
                    <img class="img-fluid rounded-circle" id="img-service-detail" :src="gallery[indexcurrentimg]" v-if="indexcurrentimg !== null">
                </div>
            </template>
        </div>
    </div>
</template>

<script>
export default {
    name: "services",

    data() {
        return {
            idslickcarousel: 'services-carousel',
            services: [],
            currentslick: null,
            serviceselected: null,
            gallery: [],
            indexcurrentimg: null,
            showservices: true
        }
    },

    created() {
        this.$parent.$on("refreshServices", this.refreshServices);

        axios.get(this.$route.meta.api + "/" + this.$root.getLanguage(), this.$root.auth)
        .then(response => {
            this.services = response.data;
            $.each(this.services, function(index, value) {
                value.index = index;
            });

            if(this.$root.idObject) {
                var thisObj = this;
                $.each(this.services, function(index, value) {
                    if(value.nid == thisObj.$root.idObject) {
                        thisObj.currentslick = value;
                        thisObj.showservices = false;
                        thisObj.$root.idObject = null;

                        thisObj.serviceDetails(value);
                    }
                });
            }
            else {
                this.$nextTick(function() {
                    this.initSlickCarousel();
                });
            }
        });
    },

    methods: {
        initSlickCarousel(currentIndex = null) {
            this.showservices = false;

            var thisObj = this;
            var id = this.idslickcarousel;

            var slidetoshow = 5;
            if(this.services.length == 4 || this.services.length == 3) {
                slidetoshow = 3;
            }
            else if(this.services.length == 2 || this.services.length == 1) {
                slidetoshow = 1;
            }
            $('#' + id).slick({
                slidesToShow: slidetoshow,
                dots: false,
                centerMode: true,
                arrows: false,
                responsive: [
                {
                    breakpoint: 1251,
                    settings: {
                        slidesToShow: 1,
                    }
                },
                {
                    breakpoint: 1921,
                    settings: {
                        slidesToShow: slidetoshow >= 3 ? 3 : 1,
                    }
                }]
            })
            .on('beforeChange', function(event, slick, currentSlide, nextSlide) {
                $('#' + id + ' div.slick-slide').addClass("nocurrent-slide");
                $('#' + id + ' [data-slick-index="' + nextSlide + '"]').removeClass("nocurrent-slide");
            })
            .on('afterChange', function(event, slick, currentSlide) {
                $('#' + id + ' div.slick-current div.img').addClass("hvr-pulse-shrink");
                
                thisObj.$root.animejs({
                    targets: '#' + id + ' div.nocurrent-slide div.img',
                    opacity: 0,
                    easing: 'easeInOutQuad',
                    duration: 250,
                    begin: function(anim) {
                        $('#' + id + ' div.nocurrent-slide div.img').addClass("d-none");
                        $('#' + id + ' div.nocurrent-slide div.item').removeClass("d-none");
                    }
                });
                thisObj.$root.animejs({
                    targets: '#' + id + ' div.nocurrent-slide div.item',
                    opacity: 1,
                    easing: 'easeInOutQuad',
                    duration: 250
                });

                thisObj.$root.animejs({
                    targets: '#' + id + ' div.slick-current div.item',
                    opacity: 0,
                    easing: 'easeInOutQuad',
                    duration: 250
                });

                thisObj.$root.animejs({
                    targets: '#' + id + ' div.slick-current div.img',
                    opacity: [0, 1],
                    easing: 'easeInOutQuad',
                    duration: 250,
                    begin: function(anim) {
                        $('#' + id + ' div.slick-current div.item').addClass("d-none");
                        $('#' + id + ' div.slick-current div.img').removeClass("d-none");
                    }
                });

                thisObj.$root.animejs.timeline({loop: false})
                .add({
                    targets: '#' + id + ' div.slick-current div.img',
                    scale: 0.9,
                    duration: 250,
                    easing: 'linear'
                })
                .add({
                    targets: '#' + id + ' div.slick-current div.img',
                    scale: 1,
                    duration: 250,
                    easing: 'linear'
                });

                thisObj.currentslick = thisObj.services[currentSlide];
            });

            if(currentIndex !== null) {
                $('#' + id).slick("slickGoTo", currentIndex);
            }

            $('#' + id).slick("refresh");

            $("#" + id + " .slick-slide .item").on("click", function() {
                var index = $(this).parent().attr("data-slick-index");
                $('#' + id).slick("slickGoTo", index);
            });
            
            this.$nextTick(function() {
                this.showservices = true;
            });
        },

        serviceDetails(service) {
            var gallery = service.field_servizi_gallery.split("|");
            this.gallery = gallery.concat(gallery);
            this.indexcurrentimg = 0;

            var thisObj = this;
            this.$root.animejs.timeline({loop: false})
            .add({
                targets: ".service-selected-0",
                opacity: [1, 0],
                duration: 500,
                easing: 'easeInOutQuad',
                complete: function(anim) {
                    thisObj.serviceselected = service;
                }
            })
            .add({
                targets: ".service-selected-1",
                opacity: [0, 1],
                duration: 500,
                easing: 'easeInOutQuad',
                begin: function(anim) {
                    var widthImg = $("#carousel-service .carousel-3d-slide.current").width();
                    $("#carousel-service").css("margin-left", "-" + (widthImg/2) + "px");
                }
            });
        },

        exitFromDetail() {
            if(this.serviceselected) {
                this.showservices = false;
                var index = this.serviceselected.index;
                
                var thisObj = this;
                this.$root.animejs.timeline({loop: false})
                .add({
                    targets: ".service-selected-1",
                    opacity: [1, 0],
                    duration: 500,
                    easing: 'easeInOutQuad',
                    complete: function(anim) {
                        thisObj.serviceselected = null;
                        thisObj.gallery = [];
                        thisObj.indexcurrentimg = null;
                    }
                })
                .add({
                    targets: ".service-selected-0",
                    opacity: [0, 1],
                    duration: 500,
                    easing: 'easeInOutQuad',
                    begin: function(anim) {
                        thisObj.initSlickCarousel(index);
                    }
                });
            }
        },

        refreshServices() {
            if(this.serviceselected) {
                this.showservices = false;
                this.serviceselected = null;
                this.gallery = [];
                this.indexcurrentimg = null;

                var thisObj = this;
                this.$root.animejs({
                    targets: ".service-selected-0",
                    opacity: [0, 1],
                    duration: 500,
                    easing: 'easeInOutQuad',
                    complete: function(anim) {
                        thisObj.initSlickCarousel();
                    }
                });
            }
        },

        onBeforeSlideChange(index) {
            this.indexcurrentimg = index;
        },

        clickSlide(event, index) {
            if($(event.target).closest('.carousel-3d-slide').hasClass("right-1")) {
                this.indexcurrentimg = index;
                this.$refs.carouselgallery.goSlide(index);
            }
        }
    }
}
</script>


// WEBPACK FOOTER //
// src/components/pages/services.vue